import { useMutation } from '@tanstack/react-query';
import type {
  TimetableScheduleBlock,
  // Deep import avoids @weareopenr/common's top-level barrel, which also re-exports its zod
  // codecs - those ship .d.cts files using TS 5 syntax this project's TS 4.9 can't parse.
} from '@weareopenr/common/build/src/validationHelper/timetable-schedule';
import { updateTimetable } from 'src/api/updateTimetable';

// Only wraps the PATCH call itself - the caller (Timetable.tsx) already owns the optimistic
// write and revert-on-failure logic for this timetable's query cache.
export const useUpdateTimetable = (timetableId?: string) =>
  useMutation({
    mutationFn: (timetableSchedule: TimetableScheduleBlock[]) =>
      updateTimetable(timetableId as string, { timetable_schedule: timetableSchedule }),
  });
